<script setup lang="ts">
const uiStore = useUIStore()
</script>

<template>
  <AddToBagPopup />
  <LoginModal />
  <SignUpModal />
  <ResetPasswordModal
    v-if="useRoute().query.resetToken"
    :reset-token="useRoute().query.resetToken"
    :login="useRoute().query.login"
  />
  <SetMyStoreModal
    :show="uiStore.isShowSetMyStoreModal"
    clear-campaign-on-close
    group="set-my-store"
    @close="uiStore.isShowSetMyStoreModal = false"
  />
  <QuickviewModal />
  <GeolocationModal />
  <ClientOnly>
    <PreviewControls />
  </ClientOnly>
</template>
